<template>
    <div class="artist">
        <AppNav />
        <!-- <div class="artist-banner" v-if="!$global.isMobile"></div> -->
        <h1 class="artist-title" v-if="!$global.isMobile"><span>{{ $t('artist') }}</span></h1>
        <div class="artist-list">
            <div class="artist-list__top">

                <template v-if="!$global.isMobile">
                    <div class="alt-left">
                        <p class="alt-left__pic" @click="currentTab = 'pic'">
                            <img :src="currentTab === 'pic' ? require('@/assets/images/pic_icon_check.png') : require('@/assets/images/pic_icon_default.png')">
                            <span :style="{ color: currentTab === 'pic' ? '#E9546B' : 'rgba(255, 255, 255, 0.6)' }">{{ $t('image_view') }}</span>
                        </p>
                        <p class="alt-left__text" @click="currentTab = 'text'">
                            <img :src="currentTab === 'text' ? require('@/assets/images/text_icon_check.png') : require('@/assets/images/text_icon_default.png')">
                            <span :style="{ color: currentTab === 'text' ? '#E9546B' : 'rgba(255, 255, 255, 0.6)' }">{{ $t('list_view') }}</span>
                        </p>
                    </div>
                    <div class="alt-right" >
                        <img class="alt-right__search" @click="clickSearch" v-if="search.type==='select'" src="@/assets/images/search_icon.png" clearable @clear="search.type='select'">

                        <el-input ref="searchInput" v-model="search.input" :placeholder="$t('pec')" v-if="search.type==='input'" :clearable="true" @clear="search.type='select'" @blur="search.type='select'">
                            <img class="alt-right__search" slot="prefix" src="@/assets/images/search_icon.png" >
                        </el-input>
                        <el-select v-else v-model="search.select" filterable :placeholder="$t('All Artists')" :popper-append-to-body="false"
                            :clearable="true" @change="selectChange">
                            <el-option v-for="item in textSortList" :key="item.id" :label="item.type[$i18n.locale]"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </template>

                <template v-else>
                    <el-radio-group v-model="currentTab" fill="#FA6400" class="list_tabs" >
                        <el-radio-button label="pic">{{ $t('image_view') }}</el-radio-button>
                        <el-radio-button label="text">{{ $t('list_view') }}</el-radio-button>
                    </el-radio-group>

                    <van-popup v-model="pick.show" position="bottom"  :close-on-click-overlay="false">
                        <van-picker 
                        :columns="textSortList"  
                        @confirm="onPickConfirm"
                        @cancel="onPickCancel"
                        show-toolbar 
                        :value-key="$i18n.locale=='CHN'?'textCHN':'textENG'"/>
                    </van-popup>
                    
                    <van-popup v-model="pick.inputShow" position="top" >
                        <van-field v-model="search.input" :label="$t('artist')" :clearable="true" :placeholder="$t('pec')" />
                    </van-popup>
                    

                    <van-button class="search-icon"  type="primary" icon="search"  round style="width: 44px;" @click="pick.inputShow=true"></van-button>
                    <van-button class="pick-icon" type="primary" icon="filter-o"  round style="width: 44px;" @click="pick.show=true"></van-button>
                    
                </template>
                
                <h1 class="artist-title" v-if="$global.isMobile">{{$t('artist') }}</h1>


            </div>
            <ListPic :list="selectPicList" v-if="currentTab == 'pic'" @artist-show="artistShow" />
            <ListText :list="selectTextList" v-if="currentTab == 'text'" @artist-show="artistShow" />

        </div>
        <ListDialog ref="dialog" />
        <Bottom />
    </div>
</template>

<script>
import { getArtists, getCategories } from '@/api/index'
import { sortData } from '@/utils'
import ListPic from './list-pic.vue'
import ListText from './list-text.vue'
import ListDialog from './list-dialog.vue'
export default {
    components: {
        ListPic, ListText, ListDialog
    },
    data() {
        return {
            currentTab: "pic",
            list: [],
            types: [],
            textList: [],
            search:{
                type:'select',
                select:"",
                input:"",
            },
            pick:{
                show:false,
                inputShow:false,
            }
        }
    },
    computed: {
        selectPicList() {
            console.log('selectPicList')
            let lang=this.$i18n.locale
            let list = this.sortList.filter(item => {
                return (this.search.select==='' || this.search.select==='all' )?true:item.type.indexOf(this.search.select) != -1
            })
            list=list.filter(item=>{
                return this.search.input===''?true:item.content[lang].name.indexOf(this.search.input) !=-1
            })
            if(this.search.select!==''){
                let sortIds=this.$store.getters['GET_ARTISTS_SORT']
                list=sortData(list, sortIds[this.search.select])
            }
            return list;
        },
        selectTextList(){
            let lang=this.$i18n.locale
            let list =  this.textSortList.filter(item=>{
                return (this.search.select==='' || this.search.select==='all' )?true: item.id===this.search.select
            })

            list=JSON.parse(JSON.stringify(list))
            list=list.filter(items=>{
                 items.artists=items.artists.filter(artist=>{
                    return this.search.input===''?true: artist.content[lang].name.indexOf(this.search.input) !=-1
                 })
                 return items.artists.length;
            })
            return list;
        },
        sortTypes(){
            let sortIds=this.$store.getters['GET_CATEGORIES_SORT']
            return sortData(this.types, sortIds)
        },
        textSortList(){
            let sortIds=this.$store.getters['GET_ARTISTS_SORT']
            let textList=[]
            let repeatList = new Set();
            if(this.sortTypes){
                textList = JSON.parse(JSON.stringify(this.sortTypes))
                textList.forEach(item => {
                    this.list.forEach(aItem => {
                        let types = aItem.type;
                        types.forEach(type => {
                            // if (item.id === type && !repeatList.has(aItem.id)) {
                            //     repeatList.add(aItem.id)
                            //     item.artists.push(aItem)
                            // }
                            if (item.id === type) {
                                // repeatList.add(aItem.id)
                                item.artists.push(aItem)
                            }
                        })

                    })
                })
            }
            textList=textList.map(item=>{
                if(sortIds[item.id])
                item.artists=sortData(item.artists, sortIds[item.id])
                return item
            })
            textList.unshift({
                id:'all',
                artists:[],
                type:{
                    CHN:'全部艺术家',
                    ENG:'All Artists',
                }
            })

            // 兼容移动端pick组件
            textList=textList.map(item=>{
                item.textCHN=item.type.CHN;
                item.textENG=item.type.ENG;
                return item
            })
            console.log(textList)

            return textList;
        },
        sortList(){
            let list=[]
            let sortIds=this.$store.getters['GET_ARTISTS_SORT']
            if(sortIds.all){
                this.list = this.list.map(item => {
                    item.types = item.type.map(tItem => {
                        let type = this.types.find(type => {
                            return type.id === tItem
                        })
                        return type.type
                    })
                    return item;
                })
                list=sortData(this.list, sortIds.all)
                return  list
            }else{
                return this.list;
            }
        },
    },
    methods: {
        onPickConfirm(v){
            this.search.select=v.id;
            this.pick.show=false
        },
        onPickCancel(){
            this.pick.show=false
        },
        selectChange(val){
            console.log(val)
        },
        clickSearch(){
            this.search.type='input'
            setTimeout(() => {
                this.$refs.searchInput.focus();

            },500);
        },
        artistShow(data) {
            this.$refs.dialog.show(data)
        },
        async getTypes() {
            let types = await getCategories()
            this.types = types.map(item => {
                return {
                    type: item.type ? JSON.parse(item.type) : '',
                    id: item.id,
                    artists: [],
                }
            })
           
            return Promise.resolve()

        },
        async getArtists() {
            let list = await getArtists()
            this.list = list.map(item => {
                return {
                    content: item.content ? JSON.parse(item.content) : '',
                    album: item.extData ? JSON.parse(item.extData) : '',
                    type: item.type ? JSON.parse(item.type) : '',
                    cover: item.cover,
                    id: item.id,
                }
            })
            return Promise.resolve()
        },
        async init() {
            await this.getTypes()
            await this.getArtists()
        }
    },
    mounted() {
        this.init()
    },
}
</script>

<style lang="less" scoped>
.artist {
    background: #02021C;
    min-height: 100%;
    overflow: hidden;

    .artist-banner {
        height: 800px;
        width: 100%;
        background: url(~@/assets/images/bg2.png) no-repeat top, url(~@/assets/images/bg1.png) no-repeat bottom;
        margin-top: 100px;
    }

    .artist-list {
        min-height: 600px;
    }

    .artist-title {
        margin-top: 140px;
        font-size: 48px;
        font-weight: 600;
        letter-spacing: 20px;
       display: flex;
       align-items: center;
       justify-content: center;
        span{
            background: linear-gradient(90deg, #E9546B 0%, #F6AC19 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
        }
    }

    .artist-list__top {
        display: flex;
        justify-content: space-between;
        height: 40px;
        margin: 40px 360px 40px;

        .alt-left {
            display: flex;
            align-items: center;
            color: rgba(255, 255, 255, 0.6);

            .alt-left__pic,
            .alt-left__text {
                cursor: pointer;
                margin-right: 32px;
                font-size: 14px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                display: flex;
                align-items: center;
                color: rgba(255, 255, 255, 0.6);
            }
        }

        .alt-right {
            display: flex;
            align-items: center;

            .alt-right__search {
                width: 24px;
                height: 24px;
                margin-right: 24px;
                cursor: pointer;
            }
        }
    }
}

::v-deep.el-input{
    .el-input__inner{
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid transparent;
        width: 303px;
        height: 40px;
        line-height: 40px;
        padding-top: 2px;
        border-radius: 20px;
        color:#fff;
        padding-left: 46px;
        position: relative;
    }
    .el-input__prefix{
        img{
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

::v-deep.el-select {
    width: 154px;
    height: 40px;

    .el-select-dropdown__list {
        padding: 0;
    }

    .el-select-dropdown__item {
        color: #fff;
        padding-top: 2px;
    }

    .el-select-dropdown {
        background: rgba(0, 0, 0, 0.4);
        border: 1px solid transparent;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        color: #02021C !important;
    }

    .el-popper[x-placement^=bottom] .popper__arrow {
        border-bottom-color: rgba(255, 255, 255, 0.1);

        &::after {
            border-bottom-color: rgba(255, 255, 255, 0.1);
        }
    }

    .el-range-editor.is-active,
    .el-range-editor.is-active:hover,
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #02021C;
    }

    .el-input__inner {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid transparent;
        border-radius: 20px;
        padding-top: 4px;
        height: 40px;
        color: #fff;
    }

    .el-range-editor.is-active,
    .el-range-editor.is-active:hover,
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #484848;
    }

    .el-input__icon {
        line-height: normal;
    }
}

::v-deep.el-radio-button {
    flex: 1;

    .el-radio-button__inner {
        width: 100% !important;
        border-radius: 0 !important;
        padding: 4vw 0;
        font-size: 5vw;
    }
}

@media screen and (max-width: 767px) {
    .artist-title {
        font-size: 8vw !important;

        height: 20vw !important;
        line-height: 20vw !important;
            background: linear-gradient(90deg, #E9546B 0%, #F6AC19 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
    }
    .artist-list{
        min-height: 100vh !important;
    }
    .artist-list__top {
        margin: 0 !important;
        height: auto !important;
        flex-direction: column;

        .list_tabs {
            display: flex;
            width: 100%;


        }
    }
    .search-icon,.pick-icon{
        position: fixed;
        right: 10px;
        bottom: 20px;
        z-index: 10;
    }
    .pick-icon{
        bottom: 70px;
    }
}
</style>